module.exports = __webpack_public_path__ + "img/icon_page_l_off.5f498703.svg";